import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_role.scss';
import Dropdown from '../Reusables/Dropdown';
import closeIcon from '../../images/popups/upload/closeicon.png';
import { useNavigate,useLocation } from "react-router-dom";
import getProfile from '../actions/Profile.js';
import RefreshToken from '../actions/RefreshToken';

const roleList = [
    {
        id: 1,
        name: "True"
    },
    {
        id: 2,
        name: "False"
    }
]
function RolepopUp(props) {
    const {show, handleClose, getContactDetails,roleId, editDetails, errormsg, create, editPopup, enable, setEnable } = props;
    const [roleType, setRoleDetails] = useState({RoleName: null, Default: null});
    const [roleLabel, setRoleLabel] = useState("Select Default");
    const [contentLabel, setContentLabel] = useState("");
    const [isLoading, setLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const [values, setValues] = useState({
        roleName: null,
        default: null,
    })
    useEffect(() => {
        console.log(roleId);
        roleId == 0 ? setContentLabel("Add Role") : setContentLabel("Edit Role");
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        search ? RolesApi(`/api/roles?search=${search}`): RolesApi(`/api/roles`);
    },[])

    useEffect(() => {
        roleId == 0 ? setContentLabel("Add Role") : setContentLabel("Edit Role");
        console.log("roleId3",editDetails)
        setRoleLabel('Select Default');
        setRoleDetails({
                ...roleType,
            RoleName: "",               
            Default: false
        })
        console.log(roleType, roleId);
    }, [create])
    useEffect(() => {
        roleId == 0 ? setContentLabel("Add Role") : setContentLabel("Edit Role");
        console.log(editDetails)
        if(roleId != 0) {
            console.log("roleId1")
            if(editDetails.length != 0) {
                var defaultValue = editDetails.default == false ? "False" : "True" 
            }
            else {
                var defaultValue = ""
            }
            setRoleLabel(defaultValue)
            setRoleDetails({
                ...roleType,
                RoleName: editDetails.roleName,
                Default: defaultValue
            })
        }
    },[editPopup])
    const RolesApi = (url) => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getProfile.GetRole(url, accesstoken, (data) => {
                    if (data.status == 200) {
                        // setUserListValues(data.data.data);
                        setLoading(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleSelectContact = (id) => {
        var defaultType = null;
        if(id == "True") {
            defaultType = true;
        } else {
            defaultType = false;
        }
        setRoleDetails({
            ...roleType,
            Default: defaultType
        })
    }

    const handleRelationship = (type) => {
        console.log(type);
        // setValues({
        //     ...values,
        //     roleName: type, 
        // })
        setRoleDetails({
            ...roleType,
            RoleName: type
        })
    }

    const RoleDefault = () => {
        var defaultType = null;
        if(roleType.Default == "True") {
            defaultType = true;
        } else {
            defaultType = false;
        }
        setRoleDetails({
            ...roleType,
            Default: defaultType
        })

    }
    const handleSave = () => {
        setEnable(false);
        RoleDefault()
        getContactDetails(roleType);
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='role-popup'
                centered>
                <Modal.Body className='role-body'>
                    <p className="error-message">{errormsg}</p>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='role-popup-header'>{contentLabel}</div>
                    <div className='role-popup-body'>
                        <div className='contact-container'>
                            <label className="required">Role Name</label>
                            <div><input type="text" value={roleType.RoleName} onChange={(e) => handleRelationship(e.target.value)}
                            maxLength={45}/></div>
                        </div>
                        <div className='relationship-container'>
                            <label >Default</label>
                            <Dropdown label={roleLabel} selectedItem={(name, id) => handleSelectContact(name)}
                                handleLabel={(value) => setRoleLabel(value)} list={roleList} enable={true}/>
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button disabled={enable ? false : true} className={enable ? 'enable' : 'disable'} onClick={handleSave}>Submit</button>
                    </div>            
                </Modal.Body>
            </Modal>
        </>
    );
}

export default RolepopUp;